export const SOB_ANALYTICS_REPORT_SETTINGS_FORM_KEY = 'SOB_ANALYTICS_REPORT_SETTINGS_FORM'
